// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mjb7A","hero":"styles_hero__7HQ6I","wrapper":"styles_wrapper__X1yXI"};